import { useState, useEffect, useRef } from 'react';

const BREAKPOINTS = {
  mobile: 640,
  tablet: 1024,
  desktop: 1440,
};

function readViewport() {
  if (typeof window === 'undefined') {
    return {
      width: 1280,
      height: 800,
      isMobile: false,
      isTablet: false,
      isDesktop: true,
      isWide: false,
      isMobileOrTablet: false,
      isTabletOrUp: true,
      isDesktopOrUp: true,
    };
  }
  const w = window.innerWidth;
  const h = window.innerHeight;
  const isMobile = w < BREAKPOINTS.mobile;
  const isTablet = w >= BREAKPOINTS.mobile && w < BREAKPOINTS.tablet;
  const isDesktop = w >= BREAKPOINTS.tablet && w < BREAKPOINTS.desktop;
  const isWide = w >= BREAKPOINTS.desktop;
  return {
    width: w,
    height: h,
    isMobile,
    isTablet,
    isDesktop,
    isWide,
    isMobileOrTablet: isMobile || isTablet,
    isTabletOrUp: !isMobile,
    isDesktopOrUp: isDesktop || isWide,
  };
}

export function useViewport() {
  const [vp, setVp] = useState(readViewport);
  const rafRef = useRef(0);

  useEffect(() => {
    if (typeof window === 'undefined') return undefined;
    const onResize = () => {
      if (rafRef.current) cancelAnimationFrame(rafRef.current);
      rafRef.current = requestAnimationFrame(() => {
        setVp(readViewport());
      });
    };
    window.addEventListener('resize', onResize, { passive: true });
    window.addEventListener('orientationchange', onResize, { passive: true });
    return () => {
      window.removeEventListener('resize', onResize);
      window.removeEventListener('orientationchange', onResize);
      if (rafRef.current) cancelAnimationFrame(rafRef.current);
    };
  }, []);

  return vp;
}

export const VIEWPORT_BREAKPOINTS = BREAKPOINTS;
